import Vue from 'vue'
import Router from 'vue-router'
import i18n from '../lang/index'
import util from '../utils/util'
import hostRouter from "./modules/host"
import serverRouter from "./modules/server"
import bareRouter from "./modules/baremetal"
import sqlRouter from "./modules/sql"
import slbRouter from "./modules/slb"
import userRouter from "./modules/user"
import dmsRouter from "./modules/dms"
import sslRouter from "./modules/ssl"
import billingRouter from "./modules/billing"
import ipRouter from "./modules/ip"
import http from '../utils/http'
import whiteRouter from "./modules/whitelist"
import ddoscdnRouter from "./modules/ddoscdn"
import workOrderRouter from "./modules/workOrder"


const originalPush = Router.prototype.push

Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

const routerOptions = {
  mode: 'history',
  routes: [{
      path: '/',
      name: 'index',
      component: () => import('@/pages/Index'),
      redirect: {
        path: '/overview'
      }
    },
    ...hostRouter,
    ...serverRouter,
    ...bareRouter,
    ...sqlRouter,
    ...slbRouter,
    ...userRouter,
    ...dmsRouter,
    ...sslRouter,
    ...billingRouter,
    ...ipRouter,
    ...whiteRouter,
    ...ddoscdnRouter,
    ...workOrderRouter
  ]
}
const router = new Router(routerOptions)

// 导航拦截
router.beforeEach((to, from, next) => {
  http.get("/general/config/websiteConfig", {}).then((response) => {
    let res = response.data.data;
    if (response.data.code !== 0) {
      message.error(response.data.message)
      return false
    }
    util.setCookie('cookieDomain', res.cookieDomain, res.cookieDomain);
    util.setCookie('agent_belong_agent', res.webHost);
    util.setCookie('yisuApiHost', res.apiHost);
    util.setCookie('siteDomain', res.apiHost);
    util.setCookie('webName', res.webTitle);
    util.setCookie('webLogo', res.cacheDomain + res.webLogo);
    if(to.meta.title) {
      document.title = to.meta.title+' - '+i18n.t('common.siteName').replace('${webTitle}', res.webTitle);
    } else {
      document.title = i18n.t('common.siteName').replace('${webTitle}', res.webTitle);
    }
    let link = document.createElement("link");
    link.href = res.cacheDomain + res.webFavicon;
    link.rel = "shortcut icon";
    document.head.appendChild(link);
    next()
  })
  .catch((err) => {
    util.delCookie('yisuApiHost')
    util.handleErr(err);
    return ;
  });


})

Vue.use(Router)

export default router



// WEBPACK FOOTER //
// ./src/router/index.js